import React from "react";
import { TextField, Box, Typography } from "@mui/material";

function humanizeLabel(key) {
  if (!key) return "";
  return key
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function FieldNumber({ name, schema = {}, value, onChange }) {
  const description = schema.description;

  const handleChange = (e) => {
    const v = e.target.value;
    // pass number when possible, otherwise empty string
    const parsed = v === "" ? "" : Number(v);
    if (onChange) onChange(parsed);
  };

  return (
    <Box mb={1} sx={{ maxWidth: 360 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {humanizeLabel(name)}:
        </Typography>
        <TextField
          type="number"
          value={value ?? ""}
          onChange={handleChange}
          size="small"
          variant="outlined"
          inputProps={{ "aria-label": humanizeLabel(name) }}
        />
      </Box>
    </Box>
  );
}
